module.exports = __webpack_public_path__ + "h5/img/logo2.16781136.png";